export default __webpack_public_path__ + "img/304d4c83bbebf532af236ea2c6161f64.svg";